'use client';

import { useApiQuery } from '@shared/api-utils';
import type { DepositLimitsResponse, PlayerLimit } from '../types';
import { getDepositLimitsPath, mapPlayerLimitsToDepositLimitsResponse } from '../utils/playerLimits';

function useDepositLimitsQuery(enabled = true) {
  return useApiQuery<PlayerLimit[], DepositLimitsResponse | null>(getDepositLimitsPath(), {
    credentials: true,
    queryOptions: {
      enabled,
      select: limits => mapPlayerLimitsToDepositLimitsResponse(limits),
    },
  });
}

export { useDepositLimitsQuery };
